import { TimeLineItem } from '../../model/timeline/timeline.model';

export const OTH_TIME_LINE: TimeLineItem[] = [
  {
    title: 'Initial commit',
    date: '27 Feb 2020',
    paragraph: 'We committed first lines of the code of the Open Template Hub at the beginning of 2020. We continued to improve our products throughout the pandemic.',
    img: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/timeline/ui/company-profile-ui-timeline-1.png',
    footerText: '#initial-commit',
  },
  {
    title: 'Hello npm',
    date: '14 Jun 2020',
    paragraph: 'Open Template Hub joined to Npm with Server Generator cli package. As of October 2021 reached to 3.5k downloads.',
    img: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/timeline/ui/company-profile-ui-timeline-2.png',
    footerText: '#hello-npm'
  },
  {
    title: 'Startup Portal',
    date: '12 Feb 2023',
    paragraph: 'Development of \'Startup Portal\' project has began.',
    img: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/timeline/ui/company-profile-ui-timeline-4.png',
    footerText: '#startup-portal'
  },
  {
    title: 'What\'s next?',
    date: '???',
    paragraph: 'We dedicate ourselves to help you to minimize the effort while building a new software. So, we are keep adding new micro-servers, user interfaces and so on. Follow us on social media to not miss them.',
    img: 'https://raw.githubusercontent.com/open-template-hub/open-template-hub.github.io/master/assets/timeline/ui/company-profile-ui-timeline-3.png',
    footerText: '#open-template-hub'
  }
];
